import { EntitySocketMessageData } from "./entity-socket-message-data";
import SocketMessage from "./socket-message";

/** When a new entity has been added */
export default class NewEntityMessage<T> extends SocketMessage<'new-entity'> {
    constructor(data: EntitySocketMessageData<T>) {
        global.executions.addLine({className: "NewEntityMessage",functionName: "[constructor]",hierarchy: ["/shared/socket/messages/new-entity-message.ts", "NewEntityMessage", "[constructor]"],fileName: "/shared/socket/messages/new-entity-message.ts",childLine: 7,line: "        super('new-entity', data)"});
        super('new-entity', data)
    }
}